import { createFileRoute, redirect } from '@tanstack/react-router';

import { getAuthSession, LoggedOut } from '@/features/auth';
import { isIframeWindow } from '@/shared/utils/utils';

export const Route = createFileRoute('/auth/_authLayout/logged-out')({
  beforeLoad: async () => {
    if (isIframeWindow()) {
      redirect({ to: '/', throw: true, replace: true });
      return;
    }

    const session = await getAuthSession();
    if (session) {
      redirect({ to: '/', replace: true, throw: true });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  return <LoggedOut />;
}
